import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from '../ui/Button';
interface HeaderProps {
  setPage: (page: string) => void;
  currentPage: string;
}
export function Header({
  setPage,
  currentPage
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    id: 'home'
  }, {
    name: 'Services',
    id: 'services-hub'
  }, {
    name: 'Industries',
    id: 'industries'
  }, {
    name: 'Gallery',
    id: 'gallery'
  }, {
    name: 'About',
    id: 'about'
  }, {
    name: 'Contact',
    id: 'contact'
  }];
  const handleNavClick = (id: string) => {
    setPage(id);
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };
  return <header className={`sticky top-0 z-40 w-full transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-4 border-b border-steel-100'}`} data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center" data-id="element-82">
        {/* Logo */}
        <button onClick={() => handleNavClick('home')} className="flex flex-col items-start focus:outline-none group" aria-label="Merem Blasting Home" data-id="element-83">
          <span className="font-heading font-extrabold text-3xl md:text-4xl text-brand-red leading-none tracking-tight group-hover:text-brand-red-dark transition-colors" data-id="element-84">
            MEREM
          </span>
          <span className="font-heading font-bold text-lg md:text-xl text-steel-700 leading-none tracking-widest mt-1" data-id="element-85">
            BLASTING
          </span>
        </button>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center space-x-8" data-id="element-86">
          <ul className="flex space-x-6" data-id="element-87">
            {navLinks.map(link => <li key={link.id} data-id="element-88">
                <button onClick={() => handleNavClick(link.id)} className={`font-heading uppercase font-semibold tracking-wider text-base transition-colors hover:text-brand-red ${currentPage === link.id ? 'text-brand-red' : 'text-charcoal'}`} data-id="element-89">
                  {link.name}
                </button>
              </li>)}
          </ul>
          <Button variant="primary" size="sm" onClick={() => handleNavClick('contact')} data-id="element-90">
            Get a Quote
          </Button>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden p-2 text-charcoal hover:text-brand-red focus:outline-none" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-91">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-92" /> : <MenuIcon className="w-6 h-6" data-id="element-93" />}
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      <div className={`lg:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t border-steel-100 transition-all duration-300 origin-top ${mobileMenuOpen ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0 pointer-events-none'}`} data-id="element-94">
        <nav className="flex flex-col px-4 py-6 space-y-4" data-id="element-95">
          {navLinks.map(link => <button key={link.id} onClick={() => handleNavClick(link.id)} className={`text-left font-heading uppercase font-bold tracking-wider text-xl py-2 border-b border-steel-100 ${currentPage === link.id ? 'text-brand-red' : 'text-charcoal'}`} data-id="element-96">
              {link.name}
            </button>)}
          <div className="pt-4" data-id="element-97">
            <Button variant="primary" className="w-full" onClick={() => handleNavClick('contact')} data-id="element-98">
              Get a Quote
            </Button>
          </div>
        </nav>
      </div>
    </header>;
}